/**
 * 논서술형 풀이 화면의 블록 단위 자동저장 + 문항 잠금 액션.
 * 학생이 답을 입력할 때마다(디바운스) 호출되는 저장 경로라, 실패해도 화면 흐름을 막지 않도록
 * throw 대신 null을 반환한다.
 */
import api from "pages/api/axiosInstance";
import {
  LockQuestionRequest,
  SaveBlockAnswerRequest,
  SaveBlockAnswerResponse,
} from "./types";

interface BaseResponse<T> {
  isSuccess: boolean;
  code: number;
  message: string;
  result: T;
}

/** 블록 답안 자동저장. `POST /app/essay-learning/questions/{questionId}/blocks` */

export const postEssayBlockSave = async (
  questionId: number,
  payload: SaveBlockAnswerRequest
): Promise<SaveBlockAnswerResponse | null> => {
  try {
    const res = await api.post<BaseResponse<SaveBlockAnswerResponse>>(
      `/app/essay-learning/questions/${questionId}/blocks`,
      payload
    );
    return res.data.result;
  } catch {
    return null;
  }
};

/**
 * 문항 단위 잠금. `POST /app/essay-learning/questions/{questionId}/lock`
 * 잠긴 문항은 /blocks 저장이 ESSAY_ANSWER_LOCKED로 거부된다.
 * 시간 있는 미션에서 "다음"·문항 시간 종료 때 부른다. 시간 없는 미션은 미션 제출이 일괄 잠근다.
 *
 * @param payload 최종 답안 칸과 남은 초. 둘 다 없으면 본문 없이 보낸다.
 * @return 응답(nextQuestionId·nextCarryInSec 포함). 실패하면 null(호출부가 이동을 막고 안내한다)
 */

export const postEssayQuestionLock = async (
  questionId: number,
  payload: LockQuestionRequest = {}
): Promise<SaveBlockAnswerResponse | null> => {
  const hasBody =
    (payload.blocks?.length ?? 0) > 0 || typeof payload.remainSec === "number";
  try {
    const res = await api.post<BaseResponse<SaveBlockAnswerResponse>>(
      `/app/essay-learning/questions/${questionId}/lock`,
      hasBody ? payload : undefined
    );
    return res.data.result;
  } catch {
    return null;
  }
};
